export const cut = <T>(array: Array<T>, limit: number): Array<T> => limit > 0 ? array.slice(0, limit) : array;

